import { Link } from 'react-router-dom';

interface ToolConversionHeaderProps {
  title: string;
  description: string;
  primaryHref: string;
  secondaryHref: string;
  secondaryLabel: string;
}

export function ToolConversionHeader({
  title,
  description,
  primaryHref,
  secondaryHref,
  secondaryLabel
}: ToolConversionHeaderProps) {
  return (
    <div className="w-full max-w-[1140px] mx-auto px-4 sm:px-6 lg:px-8 mt-8 mb-10">
      <div className="bg-gradient-to-r from-blue-900/40 to-slate-900/40 border border-blue-500/30 rounded-xl p-6 flex flex-col md:flex-row items-center justify-between gap-6 backdrop-blur-sm shadow-xl">
        <div className="flex-1 text-slate-300">
          <h2 className="text-xl font-bold text-white mb-2 flex items-center gap-2">
            <svg className="w-6 h-6 text-white" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
              <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82a7.5 7.5 0 012 0c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z" />
            </svg>
            {title}
          </h2>
          <p className="text-slate-300 text-sm md:text-base leading-relaxed">{description}</p>
          <p className="text-xs text-slate-400 mt-3">Read-only GitHub App connection. No code or settings are modified.</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <a
            href={primaryHref}
            className="btn btn-primary whitespace-nowrap px-6 py-3 shadow-lg shadow-blue-500/20 hover:shadow-blue-500/40 transition-all transform hover:-translate-y-0.5 text-base font-semibold"
          >
            Connect GitHub
          </a>
          <Link
            to={secondaryHref}
            className="inline-flex items-center justify-center gap-2 border border-slate-600 text-slate-200 px-6 py-3 rounded-lg hover:border-blue-500/60 hover:text-white transition font-semibold"
          >
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </div>
  );
}
